export const alignOptions = ['flex-start', 'center', 'flex-end'];
